import { Card, styled } from "@mui/material";

import { Library } from "#src/components/library";

export const PageContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(5),
}));

export const CardList = styled(Library)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  [`@media (min-width: ${theme.spacing(theme.layout.SCREEN_BREAK_2)})`]: {
    gridTemplateColumns: "1fr 1fr 1fr",
  },
  [`@media (min-width: ${theme.spacing(theme.layout.SCREEN_BREAK_4)})`]: {
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
  },
}));

export const HeroContainer = styled(Card)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(5),
  justifyContent: "space-evenly",
  padding: theme.spacing(10, 5),
  alignItems: "center",
}));

export const HeroItem = styled("div")(({ theme }) => ({
  padding: theme.spacing(5),
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: theme.spacing(65),
  gap: theme.spacing(2),
  textAlign: "center",
}));

export const CallsToActionContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(5),
}));

export const CallToAction = styled("section")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.spacing(2),
}));

export const Logo = styled("img")({
  width: "100%",
});
